import React, { useState } from 'react';
import { Link } from 'react-router';
import './DomesticTradesBanner.css';

const STORAGE_KEY = 'domesticTradesBanner.dismissed';

export default function DomesticTradesBanner() {
  const [dismissed, setDismissed] = useState(() => {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  });

  if (dismissed) return null;

  const handleDismiss = () => {
    localStorage.setItem(STORAGE_KEY, 'true');
    setDismissed(true);
  };

  return (
    <div className="domestic-trades-banner">
      <div className="domestic-trades-banner-content">
        <svg
          className="domestic-trades-banner-icon"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
          <path d="M2 12h20M12 2a15 15 0 0 1 0 20M12 2a15 15 0 0 0 0 20" stroke="currentColor" strokeWidth="2" />
        </svg>
        <span className="domestic-trades-banner-text">
          Showing domestic traders first based on your preferences.{' '}
          <Link to="/settings" state={{ tab: 'Preferences' }} className="domestic-trades-banner-link">
            Change in Settings
          </Link>
        </span>
      </div>
      <button
        className="domestic-trades-banner-dismiss"
        onClick={handleDismiss}
        type="button"
      >
        Dismiss
      </button>
    </div>
  );
}
